/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_UnauthorizedInputs */

const vi_error_irrigation_unauthorized = /** @type {(inputs: Error_Irrigation_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SmartLab từ chối tài khoản API tưới: kiểm tra lại tên đăng nhập, mật khẩu hoặc ngày hết hạn ở màn Cấu hình SmartLab`)
};

/**

* @param {Error_Irrigation_UnauthorizedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_unauthorized = /** @type {((inputs?: Error_Irrigation_UnauthorizedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_UnauthorizedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_unauthorized(inputs)
});